import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, ViewEncapsulation, forwardRef } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { ColorPickerConfig } from "./colorPicker.config";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ColorPickerModule } from "primeng/colorpicker";
import { VButtonComponent } from "../button/button.component";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector:    'v-color-picker',
    templateUrl: './colorPicker.component.haml',
    styleUrls:   ['./colorPicker.component.sass', '../input.style.sass'],
    providers:   [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VColorPickerComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VColorPickerComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VColorPickerComponent), multi: true }
    ],
    encapsulation:   ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      true,
    imports:         [CommonModule, ReactiveFormsModule, VButtonComponent, ColorPickerModule, TranslateModule]
})
export class VColorPickerComponent extends InputFormWrapper<ColorPickerConfig, string> implements OnDestroy {
    protected readonly _baseConfig: ColorPickerConfig = ColorPickerConfig.baseTheme.Default;
    @HostBinding('class.no-value') get noValue() { return !this.value; }
}